<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>品牌列表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="品牌ID">
          <el-input v-model="listQuery.brandId" placeholder="请输入品牌ID" clearable></el-input>
        </el-form-item>
        <el-form-item label="品牌名称">
          <el-input v-model="listQuery.brandName" placeholder="请输入品牌名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="listQuery.isEnabled" clearable placeholder="请选择状态">
            <el-option label="启用" :value="true"></el-option>
            <el-option label="停用" :value="false"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="listQuery.timePart"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
          <el-button icon="el-icon-plus" type="primary" plan @click="addBrand">新增品牌</el-button>
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column prop="id" label="ID" width="50px" fixed="left"></el-table-column>

        <el-table-column prop="brandName" label="品牌名称" width="160" fixed="left"></el-table-column>
        <el-table-column prop="brandInfo" label="品牌描述"></el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.isEnabled">启用</span>
            <span v-if="scope.row.isEnabled==false">停用</span>
          </template>
        </el-table-column>

        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="files" label="图片" width="200px">
          <template slot-scope="scope">
            <span v-if="scope.row.logo==''">无</span>
            <el-image
              v-else
              slot="reference"
              :preview-src-list="scope.row.logo.split(',')"
              v-for="item in scope.row.logo.split(',')"
              :key="item.index"
              :src="item"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormatA" width="140px"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column>

        <el-table-column prop label="操作" fixed="right" width="180px" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              @click="editBrand(scope.row)"
              :disabled="scope.row.status==2"
              size="mini"
            >编辑</el-button>
            <el-button
              type="text"
              @click="brandStatus(scope.row)"
              v-if="scope.row.isEnabled==true"
              class="red"
              size="mini"
            >停用</el-button>
            <el-button
              type="text"
              @click="brandStatus(scope.row)"
              v-if="scope.row.isEnabled==false"
              size="mini"
            >启用</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />
    </el-card>

    <!-- 新增品牌 -->
    <el-dialog
      title="新增品牌"
      :visible.sync="addBrandVisible"
      width="640px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="addBrandForm"
        :rules="addRules"
        label-width="100px"
        :model="addBrandForm"
        size="medium"
      >
        <el-row>
          <el-form-item label="品牌状态" prop="isEnabled">
            <el-select v-model="addBrandForm.isEnabled" placeholder="请选择品牌状态">
              <el-option label="启用" :value="true"></el-option>
              <el-option label="停用" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="品牌名称" prop="brandName">
            <el-input v-model="addBrandForm.brandName" clearable placeholder="请输入品牌名称"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="品牌描述" prop="brandInfo">
            <el-input v-model="addBrandForm.brandInfo" clearable placeholder="请输入品牌描述"></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              style="width:460px"
              :rows="3"
              placeholder="请输入备注"
              v-model="addBrandForm.remark"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="图片上传:"></el-form-item>
        </el-row>
        <!-- <el-row> -->
        <el-upload
          :action="addFile"
          :on-change="handleOnChange"
          :file-list="addBrandImgList"
          :limit="5"
          :on-exceed="uploadOverrun"
          :auto-upload="false"
          :on-remove="handleRemove"
          accept=".jpg, .jpeg, .png, .gif"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click=" addBrandVisible= false">取 消</el-button>
        <el-button type="primary" @click="confAddBrand('addBrandForm')">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改品牌 -->

    <el-dialog
      title="修改品牌"
      :visible.sync="editBrandVisible"
      width="640px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="editBrandForm"
        :rules="editRules"
        label-width="100px"
        :model="editBrandForm"
        size="medium"
      >
        <el-row>
          <el-form-item label="品牌状态" prop="isEnabled">
            <el-select v-model="editBrandForm.isEnabled" placeholder="请选择品牌状态">
              <el-option label="启用" :value="true"></el-option>
              <el-option label="停用" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="品牌名称" prop="brandName">
            <el-input v-model="editBrandForm.brandName" clearable placeholder="请输入品牌名称"></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="品牌描述" prop="brandInfo">
            <el-input v-model="editBrandForm.brandInfo" clearable placeholder="请输入品牌描述"></el-input>
          </el-form-item>
        </el-row>

        <el-row>
          <el-form-item label="备注" prop="remark">
            <el-input
              type="textarea"
              style="width:460px"
              :rows="3"
              placeholder="请输入备注"
              v-model="editBrandForm.remark"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="图片上传:"></el-form-item>
        </el-row>
        <!-- <el-row> -->
        <el-upload
          :action="addFile2"
          :on-change="handleOnChange2"
          :file-list="editBrandImgList"
          :limit="5"
          :on-exceed="uploadOverrun2"
          :auto-upload="false"
          :on-remove="handleRemove2"
          accept=".jpg, .jpeg, .png, .gif"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click=" editBrandVisible= false">取 消</el-button>
        <el-button type="primary" @click="confEditBrand('editBrandForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "../common/Pagination";
import Service from "@/script/api/service";
import wmsApi from "@/script/api/wmsApi";
import globalData from "@/components/common/globaldata/global.data.vue";
import "./css/index.css";
export default {
  components: { Pagination },
  data() {
    return {
      listData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        brandId: "",
        brandName: "",
        isEnabled: null,
        timePart: []
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近半个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },

      addBrandVisible: false,
      addBrandForm: {
        brandName: "",
        brandInfo: "",
        isEnabled: true,
        remark: ""
      },
      addBrandImgList: [],
      editBrandImgList: [],
      addFile: Service.addFile + globalData.userInfo.userAccount,
      addFile2: Service.addFile + globalData.userInfo.userAccount,
      addRules: {
        brandName: [
          { required: true, message: "请输入品牌名称", trigger: "change" }
        ],
        isEnabled: [
          { required: true, message: "请选择品牌状态", trigger: "change" }
        ]
      },
      brandInfo: {},
      editBrandVisible: false,
      editBrandForm: {
        brandName: "",
        brandInfo: "",
        isEnabled: true,
        remark: ""
      },
      editRules: {
        brandName: [
          { required: true, message: "请输入品牌名称", trigger: "change" }
        ],
        isEnabled: [
          { required: true, message: "请选择品牌状态", trigger: "change" }
        ]
      }
    };
  },
  created() {
    this.querySearch();
  },
  methods: {
    //查询
    querySearch() {
      let temp = {
        page: this.currentPage,
        size: this.pageSize,
        brandId: this.listQuery.brandId,
        brandName: this.listQuery.brandName,
        isEnabled: this.listQuery.isEnabled
      };
      if (
        this.listQuery.timePart != "" &&
        this.listQuery.timePart != undefined
      ) {
        temp.createTimeStart = this.listQuery.timePart[0]
          .getTime()
          .toString()
          .substr(0, 10);
        temp.createTimeEnd = this.listQuery.timePart[1]
          .getTime()
          .toString()
          .substr(0, 10);
      }
      wmsApi
        .$axiosBrandList(temp)
        .then(res => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    brandStatus(row) {
      this.$confirm(`确定${row.isEnabled ? "停用" : "启用"}该品牌吗？`)
        .then(_ => {
          if (row.isEnabled) {
            wmsApi
              .$axiosDisabledBrand({
                brandId: row.id
              })
              .then(res => {
                this.$message.success(
                  `${row.isEnabled ? "停用" : "启用"}成功！`
                );
                this.querySearch();
              })
              .catch(err => {
                console.log(err);
              });
          } else {
            wmsApi
              .$axiosAbleBrand({
                brandId: row.id
              })
              .then(res => {
                this.$message.success(
                  `${row.isEnabled ? "停用" : "启用"}成功！`
                );
                this.querySearch();
              })
              .catch(err => {
                console.log(err);
              });
          }
        })
        .catch(_ => {});
      console.log(row);
    },
    addBrand() {
      this.addBrandVisible = true;
      this.addBrandForm = {
        brandName: "",
        brandInfo: "",
        isEnabled: true,
        remark: ""
      };
      this.addBrandImgList = [];
    },
    confAddBrand(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let brandImg = this.addBrandImgList.map(item => {
            return item.url;
          });
          let params = {
            createUserId: globalData.userInfo.id,
            brandName: this.addBrandForm.brandName,
            brandInfo: this.addBrandForm.brandInfo,
            isEnabled: this.addBrandForm.isEnabled,
            remark: this.addBrandForm.remark,
            logo: brandImg.join(",")
          };

          wmsApi.$axiosAddNewBrand(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("添加成功");
              this.addBrandVisible = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editBrand(row) {
      this.brandInfo = row;
      this.editBrandVisible = true;
      let list = row.logo == "" ? [] : row.logo.split(",");
      this.editBrandImgList = list.map(item => {
        return { url: item };
      });
      this.editBrandForm = {
        brandName: row.brandName,
        brandInfo: row.brandInfo,
        isEnabled: row.isEnabled,
        remark: row.remark
      };
    },
    confEditBrand(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let brandImg = this.editBrandImgList.map(item => {
            return item.url;
          });
          let params = {
            createUserId: globalData.userInfo.id,
            brandName: this.editBrandForm.brandName,
            brandInfo: this.editBrandForm.brandInfo,
            isEnabled: this.editBrandForm.isEnabled,
            remark: this.editBrandForm.remark,
            logo: brandImg.join(","),
            id: this.brandInfo.id
          };

          wmsApi.$axiosModifyBrand(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("修改成功");
              this.editBrandVisible = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    uploadOverrun: function() {
      this.$message({
        type: "error",
        message: "上传文件个数超出限制!最多上传5张图片!"
      });
    },
    uploadOverrun2: function() {
      this.$message({
        type: "error",
        message: "上传文件个数超出限制!最多上传5张图片!"
      });
    },
    handleRemove: function(file, fileList) {
      console.log(file, fileList);
      this.addBrandImgList = fileList;
    },
    handleRemove2: function(file, fileList) {
      console.log(file, fileList);
      this.editBrandImgList = fileList;
    },
    handleOnChange(file, fileList) {
      console.log(file);
      console.log(fileList);
      if (file.raw) {
        console.log("上传文件大小" + file.raw.size);
        let param = new FormData();
        param.append("createAccount", globalData.userInfo.userAccount);
        param.append("file", file.raw);
        Service.$ajaxAddFile(param).then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            console.log(res);
            file.url = res.data.data.fileUrl;
            this.addBrandImgList = fileList;
            console.log(this.addBrandImgList);
          }
        });
      }
    },
    handleOnChange2(file, fileList) {
      console.log(file);
      console.log(fileList);
      if (file.raw) {
        console.log("上传文件大小" + file.raw.size);
        let param = new FormData();
        param.append("createAccount", globalData.userInfo.userAccount);
        param.append("file", file.raw);
        Service.$ajaxAddFile(param).then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            console.log(res);
            file.url = res.data.data.fileUrl;
            this.editBrandImgList = fileList;
            console.log(this.addBrandImgList);
          }
        });
      }
    }
  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
>>> .el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>